import { useStyletron } from 'baseui'
import { Button, SIZE, KIND } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import useContractsPagination from './useContractsPagination'

const ContractsPagination = () => {
  const [css] = useStyletron()
  const { t } = useTranslation()
  const { pagination, goToNextPage, goToPreviousPage, hasNext, hasPrevious } = useContractsPagination()

  return (
    <div
      className={css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
        padding: '1rem 0',
      })}
    >
      <Button size={SIZE.compact} kind={KIND.secondary} onClick={goToPreviousPage} disabled={!hasPrevious}>
        {t('common:previous')}
      </Button>
      <span>Page {pagination.currentPage}</span>
      <Button size={SIZE.compact} kind={KIND.secondary} onClick={goToNextPage} disabled={!hasNext}>
        {t('common:next')}
      </Button>
    </div>
  )
}

export default ContractsPagination
